module.exports = __webpack_public_path__ + "img/core-advantages-2.d17ca01f.svg";